export var initPopupCloseFunction = function () {
    $('.js-close-popup').on('click', function () {
        $(this).closest('.popup-overlay').removeClass('visible');
    });
    $('.popup-overlay').on('click', function (e) {
        var popup = $(this).find('.popup');
        if (popup.hasClass('fixed')) {
            return;
        }
        if (!popup.is(e.target) && popup.has(e.target).length === 0) {
            $(this).removeClass('visible');
        }
    });
    var $target = $('.popup-overlay');
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
                var attributeValue = jQuery(mutation.target).prop(mutation.attributeName);
                if (attributeValue.indexOf('visible') >= 0) {
                    $('body').addClass('popup-visible');
                }
                else {
                    $('body').removeClass('popup-visible');
                }
            }
        });
    });
    if ($target.length > 0) {
        $target.each(function (i) {
            observer.observe($target[i], {
                attributes: true
            });
        });
    }
};
export var activateSemanticUI = function (element) {
    //Activate eventual semantic-ui dropdowns
    var dropdown = element.find('.ui.dropdown');
    var str = dropdown.attr('data-pre-selected');
    if (str) {
        dropdown.dropdown('set selected', str.split(','));
    }
    else {
        dropdown.dropdown();
    }
};
initPopupCloseFunction();
